// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605071044/js/" + chunkId + "." + {"44":"43c24273","225":"f14dbf10","481":"954b3457","486":"03332c30","770":"64fb84d6"}[chunkId] + ".0.9773597554157596.chunk.js";
};